import { parseJwt } from '../modules/common';

export function getAdminPerformedBy(): string {
    try {
        const token = localStorage.getItem('DMS_APPLICATION');
        if (!token) return '';
        const jwt = parseJwt(token);
        const extra = JSON.parse(jwt.extra);
        return extra?.citizen_id ?? extra?.username ?? '';
    } catch {
        return '';
    }
}

export function logAdminAction(
    sourceModule: string,
    actionType: string,
    targetId: string,
    sid: string,
    detail?: string
): void {
    fetch('/v1/admin-action-log', {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${localStorage.getItem('DMS_APPLICATION') ?? ''}`,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            sourceModule,
            actionType,
            targetId,
            performedBy: getAdminPerformedBy(),
            sid,
            detail,
        }),
    }).catch(() => {});
}
